<mpro-checkbox
  #checkbox
  [indeterminate]="indeterminate"
  [label]="leftText"
  [ngModel]="checked"
  (ngModelChange)="onCheckedChange($event)"
  [loading]="loading"
  [disabled]="disabled"
  [readonly]="readonly"
></mpro-checkbox>
<span class="icons">
  <span *ngIf="rightText && !disabled" class="rightText">{{ rightText }}</span>
  <fa-icon
    *ngIf="editable"
    class="pen-icon clickable icons"
    [icon]="faPen"
    (click)="onEditClick()"
    stopClickPropagation
  ></fa-icon>
  <fa-icon
    *ngIf="editable"
    class="delete-icon clickable icons"
    [icon]="faTrash"
    (click)="onDeleteClick()"
    stopClickPropagation
  ></fa-icon>
  <fa-icon
    *ngIf="!disabled && arrow"
    [rotate]="90"
    [icon]="faSortUp"
    [class.lockGap]="showLock"
  ></fa-icon>
  <fa-icon *ngIf="showLock" [icon]="faLock"></fa-icon>
</span>
